export default [
	    {
	        "id": "permissions__access_admin_app",
	        "header": "Access Admin App",
	        "fieldName": "permissions__access_admin_app",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_reports",
	        "header": "View Reports",
	        "fieldName": "permissions__view_reports",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_dashboard",
	        "header": "View Dashboard",
	        "fieldName": "permissions__view_dashboard",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_app_configs",
	        "header": "View App Configs",
	        "fieldName": "permissions__view_app_configs",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_app_configs",
	        "header": "Add App Configs",
	        "fieldName": "permissions__add_app_configs",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_app_configs",
	        "header": "Edit App Configs",
	        "fieldName": "permissions__edit_app_configs",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_app_configs",
	        "header": "Delete App Configs",
	        "fieldName": "permissions__delete_app_configs",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_chat_messages",
	        "header": "View Chat Messages",
	        "fieldName": "permissions__view_chat_messages",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_chat_messages",
	        "header": "Add Chat Messages",
	        "fieldName": "permissions__add_chat_messages",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_chat_messages",
	        "header": "Edit Chat Messages",
	        "fieldName": "permissions__edit_chat_messages",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_chat_messages",
	        "header": "Delete Chat Messages",
	        "fieldName": "permissions__delete_chat_messages",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_chat_recipients",
	        "header": "View Chat Recipients",
	        "fieldName": "permissions__view_chat_recipients",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_chat_recipients",
	        "header": "Add Chat Recipients",
	        "fieldName": "permissions__add_chat_recipients",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_chat_recipients",
	        "header": "Edit Chat Recipients",
	        "fieldName": "permissions__edit_chat_recipients",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_chat_recipients",
	        "header": "Delete Chat Recipients",
	        "fieldName": "permissions__delete_chat_recipients",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_contents",
	        "header": "View Contents",
	        "fieldName": "permissions__view_contents",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_contents",
	        "header": "Add Contents",
	        "fieldName": "permissions__add_contents",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_contents",
	        "header": "Edit Contents",
	        "fieldName": "permissions__edit_contents",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_contents",
	        "header": "Delete Contents",
	        "fieldName": "permissions__delete_contents",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_content_types",
	        "header": "View Content Types",
	        "fieldName": "permissions__view_content_types",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_content_types",
	        "header": "Add Content Types",
	        "fieldName": "permissions__add_content_types",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_content_types",
	        "header": "Edit Content Types",
	        "fieldName": "permissions__edit_content_types",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_content_types",
	        "header": "Delete Content Types",
	        "fieldName": "permissions__delete_content_types",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_engagements",
	        "header": "View Engagements",
	        "fieldName": "permissions__view_engagements",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_engagements",
	        "header": "Add Engagements",
	        "fieldName": "permissions__add_engagements",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_engagements",
	        "header": "Edit Engagements",
	        "fieldName": "permissions__edit_engagements",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_engagements",
	        "header": "Delete Engagements",
	        "fieldName": "permissions__delete_engagements",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_groups",
	        "header": "View Groups",
	        "fieldName": "permissions__view_groups",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_groups",
	        "header": "Add Groups",
	        "fieldName": "permissions__add_groups",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_groups",
	        "header": "Edit Groups",
	        "fieldName": "permissions__edit_groups",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_groups",
	        "header": "Delete Groups",
	        "fieldName": "permissions__delete_groups",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_groups_users",
	        "header": "View Groups Users",
	        "fieldName": "permissions__view_groups_users",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_groups_users",
	        "header": "Add Groups Users",
	        "fieldName": "permissions__add_groups_users",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_groups_users",
	        "header": "Edit Groups Users",
	        "fieldName": "permissions__edit_groups_users",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_groups_users",
	        "header": "Delete Groups Users",
	        "fieldName": "permissions__delete_groups_users",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_permissions",
	        "header": "View Permissions",
	        "fieldName": "permissions__view_permissions",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_permissions",
	        "header": "Add Permissions",
	        "fieldName": "permissions__add_permissions",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_permissions",
	        "header": "Edit Permissions",
	        "fieldName": "permissions__edit_permissions",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_permissions",
	        "header": "Delete Permissions",
	        "fieldName": "permissions__delete_permissions",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_ratings",
	        "header": "View Ratings",
	        "fieldName": "permissions__view_ratings",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_ratings",
	        "header": "Add Ratings",
	        "fieldName": "permissions__add_ratings",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_ratings",
	        "header": "Edit Ratings",
	        "fieldName": "permissions__edit_ratings",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_ratings",
	        "header": "Delete Ratings",
	        "fieldName": "permissions__delete_ratings",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_screens",
	        "header": "View Screens",
	        "fieldName": "permissions__view_screens",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_screens",
	        "header": "Add Screens",
	        "fieldName": "permissions__add_screens",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_screens",
	        "header": "Edit Screens",
	        "fieldName": "permissions__edit_screens",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_screens",
	        "header": "Delete Screens",
	        "fieldName": "permissions__delete_screens",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_screen_types",
	        "header": "View Screen Types",
	        "fieldName": "permissions__view_screen_types",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_screen_types",
	        "header": "Add Screen Types",
	        "fieldName": "permissions__add_screen_types",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_screen_types",
	        "header": "Edit Screen Types",
	        "fieldName": "permissions__edit_screen_types",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_screen_types",
	        "header": "Delete Screen Types",
	        "fieldName": "permissions__delete_screen_types",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__view_users",
	        "header": "View Users",
	        "fieldName": "permissions__view_users",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__add_users",
	        "header": "Add Users",
	        "fieldName": "permissions__add_users",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__edit_users",
	        "header": "Edit Users",
	        "fieldName": "permissions__edit_users",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "permissions__delete_users",
	        "header": "Delete Users",
	        "fieldName": "permissions__delete_users",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    }
	];